import { Capacitor } from '@capacitor/core'
import { getApp, initializeApp } from 'firebase/app'
import { indexedDBLocalPersistence, initializeAuth } from 'firebase/auth'

export const getVapidKey = (): string => process.env.REACT_APP_FB_VAPID_KEY || ''

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FB_API_KEY,
  authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FB_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FB_APP_ID,
  measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID
}

export const FirebaseApp = () => {
  let app

  try {
    app = initializeApp(firebaseConfig)
  } catch (e) {
    console.log(e)
    app = getApp()
  }

  return app
}

// serviceWorker.js
export const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    await navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Service Worker registered with scope:', registration.scope)
      })
      .catch((error) => {
        console.error('Error registering service worker:', error)
      })
  }
}

export const initFirebase = () => {
  if (Capacitor.isNativePlatform()) {
    initializeAuth(FirebaseApp(), {
      persistence: indexedDBLocalPersistence
    })
  } else {
    FirebaseApp()
    registerServiceWorker()
  }
}
